import { FC, HTMLAttributes, JSX } from 'react';
import { merge } from '../../helpers/Utility';
import { Breadcrumbs, NavPage } from './Breadcrumbs';
import { PageSizer, SizerMode } from './PageSizer';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import clsx from 'clsx';

export enum PageChangeDirection {
  PREV,
  NEXT
}

interface PageHeaderProps extends HTMLAttributes<HTMLDivElement> {
  breadcrumbs?: NavPage[];
  pageTitle?: string;
  icon?: JSX.Element;
  bigHeader?: boolean;
  fullWidth?: boolean;
  centeredTitle?: boolean;
  onChangePage?: (direction: PageChangeDirection) => void;
}

export const PageHeader: FC<PageHeaderProps> = ({
  pageTitle,
  children,
  breadcrumbs,
  icon,
  bigHeader,
  fullWidth,
  centeredTitle,
  onChangePage
}) => {
  let className = 'w-full bg-secondary-std border-primary-std border-b';

  if (bigHeader) {
    className = merge(className, 'sm:-mb-16');
  }

  return (
    <div className={className}>
      <PageSizer mode={fullWidth ? SizerMode.FULL : SizerMode.HEADER}>
        {breadcrumbs && <Breadcrumbs pages={breadcrumbs} />}
        <div className={'w-full flex flex-col md:flex-row justify-between min-h-[37px]'}>
          {centeredTitle && <div id="spacer"></div>}
          <div
            className={clsx(
              'flex gap-3 items-center text-2xl font-bold',
              centeredTitle ? 'absolute w-full left-0 justify-center' : ''
            )}
          >
            {onChangePage && (
              <button onClick={() => onChangePage(PageChangeDirection.PREV)}>
                <FiChevronLeft className="w-8 h-8" />
              </button>
            )}
            {icon}
            <div>{pageTitle}</div>
            {onChangePage && (
              <button onClick={() => onChangePage(PageChangeDirection.NEXT)}>
                <FiChevronRight className="w-8 h-8" />
              </button>
            )}
          </div>
          <div>{children}</div>
        </div>
        {bigHeader && <div className="hidden sm:block h-16" />}
      </PageSizer>
    </div>
  );
};
